"use strict";

exports.__esModule = true;
var Currency = function () {
  function Currency(init) {
    Object.assign(this, init);
  }
  Currency.unformat = function (value) {
    var decimal = extractorContext.accounting.settings.number.decimal;
    var regex = new RegExp("[^0-9-" + decimal + "]", "g");
    var unformatted = parseFloat(("" + value).replace(/\((?=\d+)(.*)\)/, "-$1").replace(regex, "").replace(decimal, "."));
    return unformatted;
  };
  Currency.inferPriceValue = function (val) {
    var num = Currency.unformat(val);
    if (isNaN(num)) {
      throw new Error("Failed to parse string to price number");
    }
    return num;
  };
  Currency.inferCurrencyValue = function (val) {
    if (val.includes("£")) {
      return CurrencySymbol.GBP;
    }
    if (val.includes("€")) {
      return CurrencySymbol.EUR;
    }
    if (val.includes("C$")) {
      return CurrencySymbol.CAD;
    }
    if (val.includes("$")) {
      return CurrencySymbol.USD;
    }
    var allCurrencies = extractorContext.CountryData.currencies.all;
    var possibleValues = allCurrencies.filter(function (q) {
      return val.includes(q.code);
    });
    if (possibleValues.length) {
      return CurrencySymbol[possibleValues[0].code];
    }
    possibleValues = allCurrencies.filter(function (q) {
      return val.includes(q.symbol);
    });
    if (possibleValues.length) {
      return CurrencySymbol[possibleValues[0].code];
    }
    throw new Error("Failed to infer currency code");
  };
  Currency.toCurrency = function (val, overrideCurrencySymbol) {
    return new Currency({
      price: Currency.inferPriceValue(val),
      priceCurrency: overrideCurrencySymbol || Currency.inferCurrencyValue(val)
    });
  };
  Currency.__createTestObject = function (init) {
    return new Currency(init);
  };
  return Currency;
}();
exports["default"] = Currency;
var CurrencySymbol;
(function (CurrencySymbol) {
  CurrencySymbol["XCD"] = "XCD";
  CurrencySymbol["ARS"] = "ARS";
  CurrencySymbol["AMD"] = "AMD";
  CurrencySymbol["AWG"] = "AWG";
  CurrencySymbol["AUD"] = "AUD";
  CurrencySymbol["EUR"] = "EUR";
  CurrencySymbol["AZN"] = "AZN";
  CurrencySymbol["BSD"] = "BSD";
  CurrencySymbol["BHD"] = "BHD";
  CurrencySymbol["BDT"] = "BDT";
  CurrencySymbol["BBD"] = "BBD";
  CurrencySymbol["BYN"] = "BYN";
  CurrencySymbol["BZD"] = "BZD";
  CurrencySymbol["XOF"] = "XOF";
  CurrencySymbol["BMD"] = "BMD";
  CurrencySymbol["INR"] = "INR";
  CurrencySymbol["BTN"] = "BTN";
  CurrencySymbol["BOB"] = "BOB";
  CurrencySymbol["BOV"] = "BOV";
  CurrencySymbol["USD"] = "USD";
  CurrencySymbol["BAM"] = "BAM";
  CurrencySymbol["BWP"] = "BWP";
  CurrencySymbol["NOK"] = "NOK";
  CurrencySymbol["BRL"] = "BRL";
  CurrencySymbol["BND"] = "BND";
  CurrencySymbol["BGN"] = "BGN";
  CurrencySymbol["BIF"] = "BIF";
  CurrencySymbol["CVE"] = "CVE";
  CurrencySymbol["KHR"] = "KHR";
  CurrencySymbol["XAF"] = "XAF";
  CurrencySymbol["CAD"] = "CAD";
  CurrencySymbol["KYD"] = "KYD";
  CurrencySymbol["CLP"] = "CLP";
  CurrencySymbol["CLF"] = "CLF";
  CurrencySymbol["CNY"] = "CNY";
  CurrencySymbol["COP"] = "COP";
  CurrencySymbol["COU"] = "COU";
  CurrencySymbol["KMF"] = "KMF";
  CurrencySymbol["CDF"] = "CDF";
  CurrencySymbol["NZD"] = "NZD";
  CurrencySymbol["CRC"] = "CRC";
  CurrencySymbol["HRK"] = "HRK";
  CurrencySymbol["CUP"] = "CUP";
  CurrencySymbol["CUC"] = "CUC";
  CurrencySymbol["ANG"] = "ANG";
  CurrencySymbol["CZK"] = "CZK";
  CurrencySymbol["DKK"] = "DKK";
  CurrencySymbol["DJF"] = "DJF";
  CurrencySymbol["DOP"] = "DOP";
  CurrencySymbol["EGP"] = "EGP";
  CurrencySymbol["SVC"] = "SVC";
  CurrencySymbol["ERN"] = "ERN";
  CurrencySymbol["ETB"] = "ETB";
  CurrencySymbol["FKP"] = "FKP";
  CurrencySymbol["FJD"] = "FJD";
  CurrencySymbol["XPF"] = "XPF";
  CurrencySymbol["GMD"] = "GMD";
  CurrencySymbol["GEL"] = "GEL";
  CurrencySymbol["GHS"] = "GHS";
  CurrencySymbol["GIP"] = "GIP";
  CurrencySymbol["GTQ"] = "GTQ";
  CurrencySymbol["GBP"] = "GBP";
  CurrencySymbol["GNF"] = "GNF";
  CurrencySymbol["GYD"] = "GYD";
  CurrencySymbol["HTG"] = "HTG";
  CurrencySymbol["HNL"] = "HNL";
  CurrencySymbol["HKD"] = "HKD";
  CurrencySymbol["HUF"] = "HUF";
  CurrencySymbol["ISK"] = "ISK";
  CurrencySymbol["IDR"] = "IDR";
  CurrencySymbol["XDR"] = "XDR";
  CurrencySymbol["IRR"] = "IRR";
  CurrencySymbol["IQD"] = "IQD";
  CurrencySymbol["ILS"] = "ILS";
  CurrencySymbol["JMD"] = "JMD";
  CurrencySymbol["JPY"] = "JPY";
  CurrencySymbol["JOD"] = "JOD";
  CurrencySymbol["KZT"] = "KZT";
  CurrencySymbol["KES"] = "KES";
  CurrencySymbol["KPW"] = "KPW";
  CurrencySymbol["KRW"] = "KRW";
  CurrencySymbol["KWD"] = "KWD";
  CurrencySymbol["KGS"] = "KGS";
  CurrencySymbol["LAK"] = "LAK";
  CurrencySymbol["LBP"] = "LBP";
  CurrencySymbol["LSL"] = "LSL";
  CurrencySymbol["ZAR"] = "ZAR";
  CurrencySymbol["LRD"] = "LRD";
  CurrencySymbol["LYD"] = "LYD";
  CurrencySymbol["CHF"] = "CHF";
  CurrencySymbol["MOP"] = "MOP";
  CurrencySymbol["MKD"] = "MKD";
  CurrencySymbol["MGA"] = "MGA";
  CurrencySymbol["MWK"] = "MWK";
  CurrencySymbol["MYR"] = "MYR";
  CurrencySymbol["MVR"] = "MVR";
  CurrencySymbol["MRU"] = "MRU";
  CurrencySymbol["MUR"] = "MUR";
  CurrencySymbol["XUA"] = "XUA";
  CurrencySymbol["MXN"] = "MXN";
  CurrencySymbol["MXV"] = "MXV";
  CurrencySymbol["MDL"] = "MDL";
  CurrencySymbol["MNT"] = "MNT";
  CurrencySymbol["MAD"] = "MAD";
  CurrencySymbol["MZN"] = "MZN";
  CurrencySymbol["MMK"] = "MMK";
  CurrencySymbol["NAD"] = "NAD";
  CurrencySymbol["NPR"] = "NPR";
  CurrencySymbol["NIO"] = "NIO";
  CurrencySymbol["NGN"] = "NGN";
  CurrencySymbol["OMR"] = "OMR";
  CurrencySymbol["PKR"] = "PKR";
  CurrencySymbol["PAB"] = "PAB";
  CurrencySymbol["PGK"] = "PGK";
  CurrencySymbol["PYG"] = "PYG";
  CurrencySymbol["PEN"] = "PEN";
  CurrencySymbol["PHP"] = "PHP";
  CurrencySymbol["PLN"] = "PLN";
  CurrencySymbol["QAR"] = "QAR";
  CurrencySymbol["RON"] = "RON";
  CurrencySymbol["RUB"] = "RUB";
  CurrencySymbol["RWF"] = "RWF";
  CurrencySymbol["SHP"] = "SHP";
  CurrencySymbol["WST"] = "WST";
  CurrencySymbol["STN"] = "STN";
  CurrencySymbol["SAR"] = "SAR";
  CurrencySymbol["RSD"] = "RSD";
  CurrencySymbol["SCR"] = "SCR";
  CurrencySymbol["SLL"] = "SLL";
  CurrencySymbol["SGD"] = "SGD";
  CurrencySymbol["XSU"] = "XSU";
  CurrencySymbol["SBD"] = "SBD";
  CurrencySymbol["SOS"] = "SOS";
  CurrencySymbol["SSP"] = "SSP";
  CurrencySymbol["LKR"] = "LKR";
  CurrencySymbol["SDG"] = "SDG";
  CurrencySymbol["SRD"] = "SRD";
  CurrencySymbol["SZL"] = "SZL";
  CurrencySymbol["SEK"] = "SEK";
  CurrencySymbol["CHE"] = "CHE";
  CurrencySymbol["CHW"] = "CHW";
  CurrencySymbol["SYP"] = "SYP";
  CurrencySymbol["TWD"] = "TWD";
  CurrencySymbol["TJS"] = "TJS";
  CurrencySymbol["TZS"] = "TZS";
  CurrencySymbol["THB"] = "THB";
  CurrencySymbol["TOP"] = "TOP";
  CurrencySymbol["TTD"] = "TTD";
  CurrencySymbol["TND"] = "TND";
  CurrencySymbol["TRY"] = "TRY";
  CurrencySymbol["TMT"] = "TMT";
  CurrencySymbol["UGX"] = "UGX";
  CurrencySymbol["UAH"] = "UAH";
  CurrencySymbol["AED"] = "AED";
  CurrencySymbol["USN"] = "USN";
  CurrencySymbol["UYU"] = "UYU";
  CurrencySymbol["UYI"] = "UYI";
  CurrencySymbol["UYW"] = "UYW";
  CurrencySymbol["UZS"] = "UZS";
  CurrencySymbol["VUV"] = "VUV";
  CurrencySymbol["VES"] = "VES";
  CurrencySymbol["VND"] = "VND";
  CurrencySymbol["YER"] = "YER";
  CurrencySymbol["ZMW"] = "ZMW";
  CurrencySymbol["ZWL"] = "ZWL";
  CurrencySymbol["XBA"] = "XBA";
  CurrencySymbol["XBB"] = "XBB";
  CurrencySymbol["XBC"] = "XBC";
  CurrencySymbol["XBD"] = "XBD";
  CurrencySymbol["XTS"] = "XTS";
  CurrencySymbol["XXX"] = "XXX";
  CurrencySymbol["XAU"] = "XAU";
  CurrencySymbol["XPD"] = "XPD";
  CurrencySymbol["XPT"] = "XPT";
  CurrencySymbol["XAG"] = "XAG";
  CurrencySymbol["MRO"] = "MRO";
  CurrencySymbol["AFN"] = "AFN";
  CurrencySymbol["ALL"] = "ALL";
  CurrencySymbol["AOA"] = "AOA";
  CurrencySymbol["BYR"] = "BYR";
  CurrencySymbol["DZD"] = "DZD";
  CurrencySymbol["LTL"] = "LTL";
  CurrencySymbol["LVL"] = "LVL";
  CurrencySymbol["STD"] = "STD";
  CurrencySymbol["VEF"] = "VEF";
  CurrencySymbol["ZMK"] = "ZMK";
})(CurrencySymbol = exports.CurrencySymbol || (exports.CurrencySymbol = {}));